var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "confirmation"
  }, [_vm.simpleMode && !_vm.isReservationFailed ? [_c('div', {
    staticClass: "simple-success"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M8 12l3 3 5-5"
    }
  })])]), _c('h1', {
    staticClass: "simple-title"
  }, [_vm._v("已送出")])])] : [_vm.isReservationFailed ? [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("掛號失敗")]), _c('div', {
    staticClass: "reminder-grayscale guest-reminder"
  }, [_c('p', {
    staticClass: "guest-reminder-line"
  }, [_vm._v(_vm._s(_vm.failureMessage))])])] : [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("掛號成功")]), _vm.guestReminder ? _c('div', {
    staticClass: "reminder-grayscale guest-reminder"
  }, _vm._l(_vm.guestReminder.lines, function (line, index) {
    return _c('p', {
      key: "guest-reminder-".concat(index),
      staticClass: "guest-reminder-line"
    }, [_vm._v(" " + _vm._s(line) + " ")]);
  }), 0) : _vm._e(), _vm.reminderMessage ? _c('div', {
    staticClass: "reminder-green",
    domProps: {
      "innerHTML": _vm._s(_vm.reminderMessage)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "appointment-info"
  }, _vm._l(_vm.infoItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "info-label",
      class: item.labelColor
    }, [_vm._v(_vm._s(item.label))]), Array.isArray(item.value) ? _c('div', {
      staticClass: "info-value-group"
    }, _vm._l(item.value, function (val, vIndex) {
      return _c('span', {
        key: vIndex,
        staticClass: "info-value",
        class: item.color
      }, [_vm._v(_vm._s(val))]);
    }), 0) : _c('span', {
      staticClass: "info-value",
      class: item.color
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)]]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }